import { useLanguage } from "@/lib/i18n";
import { blogScanContent } from "./content";

export function BlogScanSteps() {
  const { language } = useLanguage();
  const c = blogScanContent[language].steps;

  return (
    <section className="mx-auto max-w-[680px] px-4 sm:px-6 py-6">
      <h2 className="font-['Source_Serif_4'] text-2xl md:text-3xl font-semibold text-foreground mt-12 mb-8">
        {c.title}
      </h2>

      <div className="space-y-10">
        {c.steps.map((step, index) => {
          const paragraphs = (step.body as string).split("\n\n");

          return (
            <div key={index}>
              <div className="flex items-start gap-4 mb-3">
                <div className="flex-shrink-0 flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-foreground text-sm font-bold font-['Funnel_Display']">
                  {index + 1}
                </div>
                <h3 className="font-['Source_Serif_4'] text-xl font-semibold text-foreground pt-0.5">
                  {step.title}
                </h3>
              </div>

              <div className="pl-12 space-y-3">
                {paragraphs.map((para, pIndex) => (
                  <p
                    key={pIndex}
                    className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85"
                  >
                    {para}
                  </p>
                ))}
              </div>

              {index === 1 ? (
                <div className="pl-12 mt-6">
                  <img
                    src="/images/blog/scan/scan-5.png"
                    alt="Numériser un reçu avec ReFound"
                    className="rounded-2xl shadow-lg max-w-[280px] mx-auto block"
                  />
                </div>
              ) : index === 2 ? (
                <div className="pl-12 mt-6 flex flex-col sm:flex-row gap-4 justify-center">
                  <img
                    src="/images/blog/scan/scan-6.png"
                    alt="Analyse du reçu par ReFound"
                    className="rounded-2xl shadow-lg max-w-[240px] w-full sm:w-auto mx-auto sm:mx-0"
                  />
                  <img
                    src="/images/blog/scan/scan-7.png"
                    alt="Informations extraites par ReFound"
                    className="rounded-2xl shadow-lg max-w-[240px] w-full sm:w-auto mx-auto sm:mx-0"
                  />
                </div>
              ) : index === 3 ? (
                <div className="pl-12 mt-6 flex flex-col sm:flex-row gap-4 justify-center">
                  <img
                    src="/images/blog/scan/scan-8.png"
                    alt="Recherche de reçu dans ReFound"
                    className="rounded-2xl shadow-lg max-w-[240px] w-full sm:w-auto mx-auto sm:mx-0"
                  />
                  <img
                    src="/images/blog/scan/scan-9.png"
                    alt="Détail d'un reçu dans ReFound"
                    className="rounded-2xl shadow-lg max-w-[240px] w-full sm:w-auto mx-auto sm:mx-0"
                  />
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </section>
  );
}
